/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Vehicle Engineering Services Side Nav Icon component.
 */
export const SideNavVehicleEngineeringServicesIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6006_2390)">
        <circle cx="7.83269" cy="17.3302" r="1.80681" stroke={iconColor} strokeWidth="1.5"/>
        <circle cx="19.3976" cy="17.3302" r="1.80681" stroke={iconColor} strokeWidth="1.5"/>
        <path d="M9.22334 17.3207H14.6891V6.10547C14.6891 5.55318 14.2414 5.10547 13.6891 5.10547H2.5C1.94772 5.10547 1.5 5.55318 1.5 6.10547V16.3207C1.5 16.873 1.94772 17.3207 2.5 17.3207H6.65406" stroke={iconColor} strokeWidth="1.5"/>
        <path d="M14.6899 7.25781L19.6084 7.25781C19.9301 7.25781 20.2321 7.41254 20.42 7.67361L23.8115 12.3852C23.934 12.5553 23.9999 12.7597 23.9999 12.9694V17.3174H21.0918M14.6899 17.3174H17.5205" stroke={iconColor} strokeWidth="1.5" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_6006_2390">
          <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  );
};
